import { gql } from '@apollo/client';

export const DELETE_PLAN_MUTATION = gql`
  mutation DeletePlan($id: uuid!) {
    delete_plans(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
